const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Banner component nests BannerTitles, so some children are expected."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be applied to Banner component."
    },
    {
        name: "description",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Text displayed under banner titles."
    },
    {
        name: "textBackground",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "Text background."
    },
    {
        name: "darkText",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "Dark text color (appropriate when image background is light)"
    },
    {
        name: "imageOverlay",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "Image overlay."
    },
    {
        name: "button",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If Button is defined it must come with its custom label."
    },
    {
        name: "buttonLabel",
        type: "string",
        defaultValue: "false",
        isRequired: "false",
        description: "Button label."
    },
    {
        name: "horizontalAlignment",
        type: "right/center",
        defaultValue: "false",
        isRequired: "false",
        description:
            "Horizontal alignment. Default position is Left-aligned. Possible values: right/center"
    },
    {
        name: "verticalAlignment",
        type: "top/bottom",
        defaultValue: "false",
        isRequired: "false",
        description:
            "Horizontal alignment. Default position is Lvertically centered. Possible values: top/bottom"
    },
    {
        name: "height",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Banner height in pixels. Possible values: 60, 90, 125, 150, 240, 250, 400, 600"
    },
    {
        name: "width",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Banner width in pixels. Possible values: 120, 125, 160, 180, 234, 240, 250, 300, 468, 728"
    },
    {
        name: "image",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The path to the background image (standard src for img tag)."
    },
    {
        name: "href",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Full URL path to the place of what we want to redirect."
    },
    {
        name: "hrefTarget",
        type: "String",
        defaultValue: "blank",
        isRequired: "false",
        description:
            "Reference to the standard HTML target attribute of the anchor tag. One of: ['blank', 'self', 'parent', 'top', 'framename']."
    }
];

export default documentedProperties;
